import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=827f60e0&scoped=true"
import script from "./SearchFilter.vue?vue&type=script&lang=js"
export * from "./SearchFilter.vue?vue&type=script&lang=js"
import style0 from "./SearchFilter.vue?vue&type=style&index=0&id=827f60e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827f60e0",
  null
  
)

export default component.exports